<!-- eslint-disable vue/no-v-html -->
<template>
  <div class="richtextresolver">
    <template v-for="row in renderedRows">
      <component
        :is="`Wizco${row.blok.component}`"
        v-if="row.blok"
        :key="`c_${row.index}`"
        :blok="row.blok"
      />
      <img
        v-else-if="row.image?.src"
        :key="`i_${row.index}`"
        :src="row.image.src"
        :alt="row.image.alt"
        :title="row.image.title"
        :data-copyright="row.image.copyright"
        loading="lazy"
      />
      <div
        v-else
        :key="`t_${row.index}`"
        :class="row.addClasses"
        class="text"
        v-html="row.html"
      ></div>
    </template>
  </div>
</template>

<script setup>
import { computed } from 'vue'
import { useStoryblokApi } from '@storyblok/vue'

const props = defineProps({
  blok: {
    type: Object,
    required: false,
    default: () => {}
  }
})
const renderedRows = computed(() => {
  const arrayOfKnots = []
  props.blok.content.forEach((textSectionObject, index) => {
    if (textSectionObject.type === 'blok') {
      textSectionObject.attrs?.body.forEach((blok) => {
        arrayOfKnots.push({
          index,
          blok
        })
      })
    } else {
      if (textSectionObject.content && textSectionObject.content[0].type === 'image') {
        arrayOfKnots.push({
          index,
          image: textSectionObject.content[0].attrs
        })
      } else {
        const addClasses = []
        const nextTextSectionObject = props.blok.content[index + 1]
        if (
          nextTextSectionObject?.type === 'blok' &&
          nextTextSectionObject.attrs?.body[0].component === 'Tooltip'
        ) {
          addClasses.push('surroundNextBlockInline')
        }
        let html = useStoryblokApi().richTextResolver.render({
          type: 'doc',
          content: [textSectionObject]
        })
        html = html
          .replace('<a ', '<a onClick="event.stopPropagation()" ')
          .replace('//a.storyblok.com', '//assets.pflege.de')
          .replace('//inko/', '/inko/') // quick and dirty fix for this issue: https://github.com/storyblok/storyblok-nuxt/issues/289 (should resolve in: https://pflegede.atlassian.net/browse/DEVCOM2-955)
        arrayOfKnots.push({
          index,
          html,
          addClasses
        })
      }
    }
  })
  return arrayOfKnots
})
</script>

<style>
.richtextresolver .surroundNextBlockInline,
.richtextresolver .surroundNextBlockInline > *,
.richtextresolver .surroundNextBlockInline + * + *,
.richtextresolver .surroundNextBlockInline + * + * > * {
  display: inline;
}

.richtextresolver img {
  max-width: 100%;
}

.inline-block {
  display: inline-block;
}

.input .message-hint .richtextresolver p {
  margin-block: 0;
}
</style>
